import React from 'react';
import { createHighlighter } from '../utils/searchHighlight';

// Тот же вид, что у сниппета в выдаче боковой панели (AppSidebar).
export const MARK_CLASS = 'bg-paper-accent/15 text-paper-ink rounded-[2px]';

/**
 * Текст с подсвеченными вхождениями — элементами React, не `innerHTML`.
 * Без `highlighter` возвращает сам текст: разметка остаётся прежней.
 */
export function withHits(text, highlighter) {
  if (!highlighter || !text) return text;
  const parts = highlighter(text);
  if (parts.length === 1 && !parts[0].hit) return text;
  return parts.map((p, i) => (p.hit
    ? <mark key={i} data-search-hit="true" className={MARK_CLASS}>{p.text}</mark>
    : <React.Fragment key={i}>{p.text}</React.Fragment>));
}

/**
 * rehype-плагин для react-markdown: режет текстовые узлы уже собранного
 * HTML-дерева и оборачивает вхождения в `<mark data-search-hit>`. Разметку
 * markdown (заголовки, списки, жирный) не трогает и не пересобирает строкой.
 * Подключение: `rehypePlugins={[[rehypeSearchHits, query]]}`.
 */
export function rehypeSearchHits(query) {
  return (tree) => {
    const hl = createHighlighter(query);
    const walk = (node) => {
      if (!Array.isArray(node.children)) return;
      node.children = node.children.flatMap((child) => {
        if (child.type !== 'text') {
          walk(child);
          return [child];
        }
        const parts = hl(child.value);
        if (parts.length === 1 && !parts[0].hit) return [child];
        return parts.map((p) => (p.hit
          ? {
            type: 'element',
            tagName: 'mark',
            properties: { dataSearchHit: 'true', className: MARK_CLASS.split(' ') },
            children: [{ type: 'text', value: p.text }],
          }
          : { type: 'text', value: p.text }));
      });
    };
    walk(tree);
  };
}
